module.exports = __webpack_public_path__ + "static/gp-logo-fa42ddceae0cf611f49a5ce13de9aa30.png";